package com.milta.core.localization.translations.de

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Abbrechen",
    confirm = "Bestätigen",
    save = "Speichern",
    delete = "Löschen",
    back = "Zurück",
    loading = "Wird geladen…",
    retry = "Erneut versuchen",
    creationInProgressDoNotClose = "Erstellung läuft, Fenster nicht schließen",
    processingStepSent = "Dokument gesendet",
    processingStepReading = "Dokument wird gelesen",
    processingStepFinding = "Lieferungen werden erkannt",
    processingStepChecking = "Adressen werden geprüft",
    processingUsualDuration = "Meist 20 bis 40 Sekunden. Bleiben Sie auf diesem Bildschirm, wir kümmern uns um den Rest.",
    processingLongWait = "Ihr Dokument enthält viele Informationen, die Analyse dauert etwas länger als üblich. Alles funktioniert, wir machen weiter.",
    processingInProgressSince = "Läuft seit %1",
    processingFinishedIn = "Abgeschlossen in %1",
    processingDeliveriesFound = "%1 Lieferungen gefunden",
    processingDeliveriesFoundOne = "1 Lieferung gefunden",
    processingAddressesChecked = "%1 von %2 Adressen",
    addressVerifiedBadge = "✓ Adresse geprüft",
    addressNeedsReviewBadge = "⚠ Adresse zu überprüfen",
    addressFoundLine = "Gefunden: %1",
    language = "Sprache",
    welcomeTitle = "Willkommen bei Milta",
    welcomeSubtitle = "Ihr intelligenter Zustellassistent",
    alreadyHaveAccount = "Ich habe bereits ein Konto",
    createAccount = "Konto erstellen",
    continueWithGoogle = "Weiter mit Google",
    continueWithApple = "Weiter mit Apple",
    oauthErrorGeneric = "Bei der Anmeldung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    oauthAppleWebComingSoon = "Die Anmeldung mit Apple ist im Web bald verfügbar.",
    oauthDriverAccountNotAllowedOnWeb = "Fahrerkonten können nicht auf das Web-Dashboard zugreifen. Bitte melden Sie sich über die mobile App an.",
    oauthAccountNotFoundOnWeb = "Für dieses Google-Konto wurde kein Milta-Konto gefunden.",
    errorOffline = "Keine Internetverbindung.",
    navTourneesDuJour = "Heutige Touren",
    navAjouterUneTournee = "Tour hinzufügen",
    navHistoriqueDesPreuves = "Zustellverlauf",
    navParametres = "Einstellungen",
    sidebarRoleManagerLabel = "Manager",
    noDeliveriesYetTitle = "Noch keine Lieferung",
    noDeliveriesYetSubtitle = "Tippen Sie auf „Lieferungen hinzufügen“, um welche hinzuzufügen",
    optimizationUnavailableExplanation = "Möchten Sie die Tour ohne Optimierung erstellen oder es erneut versuchen?",
    createWithoutOptimizationAction = "Ohne Optimierung erstellen",
    gpsAppSheetTitle = "Navigations-App auswählen",
    addressSearchingLabel = "Suche läuft…",
    clearTimeFieldAction = "Löschen",
    clearTimeFieldConfirmTitle = "Uhrzeit löschen?",
    clearTimeFieldConfirmMessage = "Die aktuelle Uhrzeit wird entfernt. Sie können jederzeit eine neue festlegen.",
    updateRequiredTitle = "Update erforderlich",
    updateRequiredMessage = "Eine neue Version von Milta ist verfügbar. Aktualisieren Sie die App, um sie weiter zu nutzen.",
    updateInstalledVersionLabel = "Installiert",
    updateAvailableVersionLabel = "Verfügbar",
    updateNowButton = "Aktualisieren",
    updateDataKeptNote = "Ihre Touren und Lieferungen bleiben erhalten.",
    updateSendingPendingOne = "1 offline bestätigte Lieferung wird gesendet…",
    updateSendingPendingMany = "{count} offline bestätigte Lieferungen werden gesendet…",
)
